import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  NavbarAdmin,
  Modal,
  Resizer,
} from "../../components/CustomComponent.js";
import Footer from "../../components/FooterAdmin.js";
export default class Tiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],

      tab: "th",

      uid: "",
      link: "",
      th_message: "",
      us_message: "",
      jp_message: "",
      cn_message: "",
    };
  }

  async componentDidMount() {
    loading(false);
  if (!profile || profile?.ep < new Date().getTime()) {
         localStorage.removeItem("scp-profile");
         alert(
           "/login",
           "warning",
           "แจ้งเตือน",
           "Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
         );
       }else{
         await this.Get();
       }
  }
  Get = async () => {
    loading(true);
    let response = await fetch(
      process.env.REACT_APP_API_URL + `/demonstration.json`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    this.setState({ data: result ? Object.values(result) : [] });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, link, th_message,
us_message,
jp_message,
cn_message } = this.state;
    loading(true);

    let now = new Date().getTime();
    await fetch(
      process.env.REACT_APP_API_URL +
        `/demonstration/${uid || now}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: uid || now,
          link,
          th_message,
us_message,
jp_message,
cn_message
        }),
      }
    );

    await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ last_update: new Date().getTime() }),
    });
    alert("#", "success");
    loading(false);
  };
  Delete = async (uid) => {
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบข้อมูลนี้หรือไม่?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      await fetch(
        process.env.REACT_APP_API_URL + `/demonstration/${uid}.json`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ last_update: new Date().getTime() }),
      });
      alert("#", "success");
      loading(false);
    }
  };

  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      data,
      tab,

      link,
      th_message,
us_message,
jp_message,
cn_message,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <NavbarAdmin />
        <div className="body p-3 mt-3">
          <h4 className="fw-bold mb-4">วิดีโอสาธิต</h4>
          <div className="rounded-3 bg-white p-3 mb-3">
            <h5 className="fw-bold mb-3">
              <span className="icon me-1 text-14">{"\uf0b0"}</span>ฟิลเตอร์
            </h5>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="Search..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                value={filter_search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-warning px-3 me-2 mb-2"
                  onClick={() => {}}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({ filter_search: "" });
                  }}
                >
                  ล้างข้อมูล
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-dark px-4"
              onClick={() => {
                this.setState({
                  modal_create: true,
                  tab:"th",
                  link: "",
                  message: "",
                });
              }}
            >
              สร้างวิดีโอสาธิต
            </button>
          </div>
          <div className="rounded-3 bg-white p-3">
            <div className="table-responsive">
              <table className="table table-hover table-striped-columns">
                <thead>
                  <tr>
                    <td>วิดีโอสาธิต</td>
                    <td>ข้อความ</td>
                    <td className="wpx-80 text-center">จัดการ</td>
                  </tr>
                </thead>
                <tbody>
                  {data
                    ?.filter(
                      (item) =>
                        !filter_search || item.message.includes(filter_search)
                    )
                    .map((item, index) => (
                      <tr key={`array-${index}`}>
                        <td>
                          <div className="d-flex">
                            <BtnIcon
                              type="approve"
                              onClick={() => {
                                window.open(item.link, "_blank");
                              }}
                              className="me-2"
                            />
                            {item.link}
                          </div>
                        </td>
                        <td>{item.th_message}</td>
                        <td>
                          <div className="w-100 d-flex justify-content-center">
                            <BtnIcon
                              type="update"
                              onClick={() => {
                                this.setState({ modal_update: true, ...item });
                              }}
                            />
                            <BtnIcon
                              type="delete"
                              onClick={() => {
                                this.Delete(item.uid);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

<div className="hpx-40"></div>
                <Footer />
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_create ? "สร้าง" : modal_update ? "แก้ไข" : ""}วิดีโอสาธิต
            </h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
            <div
              className="border-primary rounded-4 d-flex"
              style={{ padding: 2 }}
            >
              <button
                className={`btn btn-${tab === "th" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "th" });
                }}
              >
                ไทย
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "us" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "us" });
                }}
              >
                อังกฤษ
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "jp" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "jp" });
                }}
              >
                ญี่ปุ่น
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "cn" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "cn" });
                }}
              >
                จีน
              </button>
            </div>
          </div>
            <div className="d-flex mb-2">
              <div className="wpx-100 mt-2">link youtube{required}</div>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control"
                  placeholder="วิดีโอสาธิต.."
                  onChange={(e) => {
                    this.setState({ link: e.target.value });
                  }}
                  value={link}
                />
                <small className="text-secondary text-10">
                  ตัวอย่าง : https://www.youtube.com/watch?v=D5vs7uW6n4o
                </small>
              </div>
            </div>
              {tab === "th" && (<div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ข้อความ (TH){required}</div>
              <textarea
                className="form-control"
                placeholder="ข้อความ.."
                rows={5}
                onChange={(e) => {
                  this.setState({ th_message: e.target.value });
                }}
                value={th_message}
              />
            </div></div>
              )}
            {tab === "us" && (<div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ข้อความ (EN)</div>
              <textarea
                className="form-control"
                placeholder="ข้อความ.."
                rows={5}
                onChange={(e) => {
                  this.setState({ us_message: e.target.value });
                }}
                value={us_message}
              />
            </div></div>
              )}
            {tab === "jp" && (<div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ข้อความ (JP)</div>
              <textarea
                className="form-control"
                placeholder="ข้อความ.."
                rows={5}
                onChange={(e) => {
                  this.setState({ jp_message: e.target.value });
                }}
                value={jp_message}
              />
            </div></div>
              )}
            {tab === "cn" && (<div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ข้อความ (CN)</div>
              <textarea
                className="form-control"
                placeholder="ข้อความ.."
                rows={5}
                onChange={(e) => {
                  this.setState({ cn_message: e.target.value });
                }}
                value={cn_message}
              />
            </div></div>)}
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
